import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import RegisterAnagrafica from "../views/RegisterAnagrafica.vue";
import Profilo from "../views/Profilo.vue";
import Messaggi from "../views/Messaggi.vue";
import VerifyEmail from "../views/VerifyEmail.vue";
import CalendarioConsulti from "../views/CalendarioConsulti.vue";
import VideoConferenza from "../views/VideoConferenza.vue";
import PrenotazioneConsulto from "../views/paziente/PrenotazioneConsulto.vue";
import AvvioConsultoPaziente from "../views/paziente/AvvioConsultoPaziente.vue";
import AvvioConsultoProfessionista from "../views/professionista/AvvioConsultoProfessionista.vue";
import NuovoQuestionario from "../views/admin/NuovoQuestionario.vue";
import NuovoAbbonamento from "../views/admin/NuovoAbbonamento.vue";
import ListaUtenti from "../views/admin/ListaUtenti.vue";
import ListaAbbonamenti from "../views/admin/ListaAbbonamenti.vue";
import NuovaCategoria from "../views/admin/NuovaCategoria.vue";
import NotFound from "../views/NotFound.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/profilo",
    name: "Profilo",
    component: Profilo,
  },
  {
    path: "/anagrafica",
    name: "RegisterAnagrafica",
    component: RegisterAnagrafica,
  },
  {
    path: "/messaggi",
    name: "Messaggi",
    component: Messaggi,
  },
  {
    path: "/videoconferenza/:type/:hash",
    name: "VideoConferenza",
    component: VideoConferenza,
  },
  {
    path: "/calendario/:tipo",
    name: "CalendarioConsulti",
    component: CalendarioConsulti,
  },
  {
    path: "/paziente/prenotazione",
    name: "PrenotazioneConsulto",
    component: PrenotazioneConsulto,
  },
  {
    path: "/paziente/consulto/avvio/:rif",
    name: "AvvioConsultoPaziente",
    component: AvvioConsultoPaziente,
  },
  {
    path: "/professionista/consulto/avvio/:rif",
    name: "AvvioConsultoProfessionista",
    component: AvvioConsultoProfessionista,
  },
  {
    path: "/admin/questionario/new",
    name: "NuovoQuestionario",
    component: NuovoQuestionario,
  },
  {
    path: "/admin/abbonamento/new",
    name: "NuovoAbbonamento",
    component: NuovoAbbonamento,
  },
  {
    path: "/admin/categoria/new",
    name: "NuovaCategoria",
    component: NuovaCategoria,
  },
  {
    path: "/admin/utenti/all",
    name: "ListaUtenti",
    component: ListaUtenti,
  },
  {
    path: "/admin/abbonamenti/all",
    name: "ListaAbbonamenti",
    component: ListaAbbonamenti,
  },
  {
    path: "/verify-email",
    name: "VerifyEmail",
    component: VerifyEmail,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () =>
    //   import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/404",
    name: "NotFound",
    component: NotFound,
  },
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "*",
    redirect: "/404",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
